import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./Eng.json";
import hi from "./Hin.json";
import ar from "./Arb.json";
import { getStoredLangCode, setStoredLangCode } from "../utils/language";

// Heal legacy Eng/Hin/Arb values stored before normalization.
const initialLng = setStoredLangCode(getStoredLangCode());

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
    ar: { translation: ar },
  },
  lng: initialLng,
  fallbackLng: "en",
  supportedLngs: ["en", "hi", "ar"],
  nonExplicitSupportedLngs: true,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
